import Icon from '@/components/editor/Icon.vue';
import {
    EAutocomplete,
    EButton,
    ECheckbox,
    ECollapse,
    EDatepicker,
    EDatetimepicker,
    EDropdown,
    EDropdownItem,
    EField,
    EIcon,
    EInput,
    ELoading,
    EMenu,
    EMenuItem,
    EMenuList,
    EMessage,
    EModal,
    EMultiselect,
    ENotification,
    ENumberinput,
    EPagination,
    EProgress,
    ERadio,
    ERadioButton,
    ESelect,
    ESidebar,
    ESkeleton,
    ESlider,
    EStepItem,
    ESteps,
    ESwitch,
    ETabItem,
    ETable,
    ETableColumn,
    ETabs,
    ETag,
    ETaginput,
    ETaglist,
    ETimepicker,
    ETooltip,
    EUpload,
} from '@/components/ui';
import LoadingSpinner from '@/components/utilities/LoadingSpinner.vue';
import VButton from '@/components/utilities/VButton.vue';

export default function registerGlobalComponents(app) {
    [
        VButton,
        LoadingSpinner,
        Icon,
        EIcon,
        EButton,
        EInput,
        EField,
        ETag,
        ECheckbox,
        EDropdown,
        EDropdownItem,
        ETaglist,
        ETooltip,
        EModal,
        ECollapse,
        EDatepicker,
        ELoading,
        EMessage,
        ERadio,
        ESelect,
        ESkeleton,
        ESwitch,
        EAutocomplete,
        EDatetimepicker,
        EPagination,
        EProgress,
        ETable,
        ETableColumn,
        ERadioButton,
        ETabItem,
        ETabs,
        ETimepicker,
        EMenuItem,
        ENotification,
        ENumberinput,
        ESidebar,
        EStepItem,
        ETaginput,
        EMultiselect,
        EMenu,
        EMenuList,
        ESlider,
        ESteps,
        EUpload,
    ].forEach(Component => {
        app.component(Component.name, Component);
    });

    // Register sidebar component with kebab-case name for menu system
    // Use dynamic import to avoid loading Page/PageFolder models during test setup
    if (typeof import.meta.env?.VITEST === 'undefined') {
        import('@/components/administration/institution-settings/InstitutionSettingsSidebar.vue').then(module => {
            app.component('institution-settings-sidebar', module.default);
        });
    }
}
